const admin = resolve => require(['@/views/admin/index.vue'], resolve) // 主页
const accountSign = (resolve) =>
  require(['@/views/admin/accountSign.vue'], resolve)
const accountBalance = (resolve) =>
  require(['@/views/admin/accountBalance.vue'], resolve)
export default [
  {
    path: '/admin/whoisyourdaddy',
    component: admin
  },
  {
    path: '/admin/homepage',
    component: accountSign
  },
  {
    path: '/admin/accountBalance',
    component: accountBalance
  }

]
